<script>
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";
import { vodafoneLabAuthorizationMixin, vodafoneLabBasicMixin } from "../../modules/vodafone_lab_mixins_module.js";
import lockIcon from "!!raw-loader!../../images/lock.svg";
import collectionIcon from "!!raw-loader!../../images/collection-icon.svg";
import collectionIconLight from "!!raw-loader!../../images/collection-icon-light.svg";
import { get } from 'lodash';


export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, vodafoneLabAuthorizationMixin, vodafoneLabBasicMixin],
  data() {
    return {
      bgVideoActive: false,
    };
  },
  props: {
    forceMobileThumbnail: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getContentURL: Fandom.getContentURL,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    getTileThumbnailUrl() {
      let url = this.exists(this.content.thumbnail) ? this.getContentResponsiveImageURL("thumbnail") : this.getContentResponsiveImageURL("image");
      if (this.exists(url)) {
        url = url.replace('/original/', '/thumb/');
      }
      return url;
    },
    getContentResponsiveImage(name) {
      const content = this.content;
      if ((globalState.viewport["sm"] || globalState.viewport["xs"]) && this.exists(content[`${name}_mobile`])) {
        return this.expandUrl(content[`${name}_mobile`].url);
      } else if (this.exists(content[name])) {
        return this.expandUrl(content[name].url);
      }
      return null;
    },
    getContentResponsiveImageURL(name) {
      const imageUrl = this.getContentResponsiveImage(name);
      return this.exists(imageUrl) ? `url("${imageUrl}")` : null;
    }
  },
  mounted() {
    this.content.theme = this.backgroundImage ? "dark" : "light";
    Vue.nextTick(() => {
      if (this.content.text_stroke) {
        $("h1").addClass("text-stroke")
      }
    });
  },
  computed: {
    buttonTitle() {
      const buttonTitle = get(this, ["content", "button_title"], this.ft("globals.see_content"));
      return get(this, ["content", "url", "title"], buttonTitle);
    },
    childrenCount() {
      return this.content.children_count;
    },
    linkLabelClasses() {
      const colors = this.content.theme == "dark" ? "text-white" : "text-primary";
      return this.authorized ? colors : "disabled";
    },
    lockIconClasses() {
      const colors = this.content.theme === "dark" ? "bg-white text-primary" : "bg-primary text-white";
      return [
        colors,
        this.backgroundImage ? "full-right" : ""
      ];
    },
    collectionIconClasses() {
      const colors = this.content.theme === "dark" ? "text-white" : "text-dark";
      return [
        colors,
        this.backgroundImage ? "full-right" : ""
      ];
    },
    contentUrl() {
      return this.authorized ? this.getContentURL(this.content) : false;
    },
    backgroundImage() {
      if (this.content.thumbnail && this.content.image_mode == "background") {
        let thumbnail = null;
        if (this.forceMobileThumbnail) {
          thumbnail = get(this.content, ['thumbnail_mobile', 'url'], false) || get(this.content, ['image_mobile', 'url'], false);
        }
        return thumbnail ? `url(${thumbnail})` : this.getTileThumbnailUrl();
      }
      return false;
    },
    sideImage() {
      if (this.content.thumbnail && (this.content.image_mode == "side" || !this.content.image_mode)) {
        return this.getTileThumbnailUrl();
      }
      return false;
    },
    componentTag() {
      return this.authorized ? "a" : "div";
    },
    lockIcon() {
      return lockIcon;
    },
    contentTitleClass() {
      return this.isCollectionTile ? 'h4 font-weight-bold' : this.content.title_class || 'h4 font-weight-bold';
    },
    isCollectionTile() {
      return this.content.parent_names.includes('content-type-collezione')
    },
    collectionIcon() {
      const icon = this.content.theme === "dark" ? collectionIcon : collectionIconLight;
      return icon;
    },
    isVertical() {
      return this.content.vertical || this.vertical
    },
    isUltrawideContent() {
      return this.content.isotope_size === "ultrawidecontent"
    },
    isCustomContent() {
      return this.content.button_icon_class || this.content.parent_names.includes('content-type-video');
    },
    iconClass() {
      return this.content.button_icon_class ? this.content.button_icon_class
        : this.content.parent_names.includes('content-type-video') ? 'fas fa-play ml-1 font-base' : 'far fa-chevron-right'
    }
  }
};
</script>

<template>
  <component
    tile-component
    :style="theme"
    :class="contentType"
    :is="componentTag"
    v-easyadmin="easyadminId"
    class="position-relative d-block tile-shadow"
    :href="contentUrl"
    :target="getTarget(content.url)"
    v-if="isContentVisibleToUser()"
  >
    <div
      v-if="!authorized"
      class="position-absolute-center locked-layer w-100 h-100 cursor-pointer"
      @click.prevent="mayRedirectOnFreeContent(true)"
      >
    </div>
    <div class="bg-cover-center position-absolute-center background" v-if="backgroundImage" :style="{'background-image': backgroundImage}">
      <div class="bg-custom-gradient position-absolute" v-if="content.icon && !content.hide_gradient"></div>
      <div class="icon-container d-inline-block position-absolute" :class="content.theme == 'dark' ? 'text-white' : 'text-dark'" v-if="childrenCount">
        {{childrenCount}} <span :class="collectionIconClasses" v-html="collectionIcon">
          </span>
      </div>
    </div>
    <div class="d-flex flex-column-reverse tile__content h-100" :class="[this.content.theme == 'dark' ? 'text-white' : 'text-dark', {'flex-md-row': !isVertical}]">
      <div class="tile__text-section p-4 d-flex flex-column justify-content-between h-100" :class="[{'col-md-6': isUltrawideContent}, content.text_container_class]">
        <div>
          <div
            v-if="category"
            class="tile__category category small mb-3 d-inline-block px-3 py-1"
            :class="content.category_class ? content.category_class : content.theme == 'dark' ? 'white' : 'dark'"
          >
            <div class="d-flex align-items-center">
              <img v-if="categoryIcon && categoryIcon.url" :src="categoryIcon.url" class="category-icon mr-2"/> 
              <i v-else-if="categoryIcon" class="fas mr-2" :class="`fa-${categoryIcon}`"></i>
              {{category}}
            </div>
          </div>
          <component :is="content.text_stroke ? 'h1' : 'p'" :class="contentTitleClass" v-if="content.title" class="dotdotdot-title" :style="{'color': content.text_color}">{{content.title}}</component>
          <p v-if="content.subtitle" v-html="content.subtitle" class="dotdotdot-subtitle" :style="{'color': content.text_color}"></p>
        </div>
        <div class="d-flex align-items-center justify-content-between" v-if="!content.text_stroke">
          <span class="d-flex align-items-center justify-content-between cursor-pointer link-label" :class="linkLabelClasses">
            <div v-if="isCustomContent" class="tile-icon-container d-flex justify-content-center align-items-center" :class="content.theme == 'dark' ? 'white' : 'primary'">
              <i :class="iconClass"></i>
            </div>
            <i v-else class="far fa-chevron-right"></i>
            <span class="ml-2">{{buttonTitle}}</span>
          </span>
          <span class="d-flex align-items-center p-3 lock-icon" v-if="!authorized" :class="lockIconClasses" v-html="lockIcon">
          </span>
        </div>
      </div>
      <div class="tile__image-section" v-if="sideImage">
        <div class="ar-16by9 h-100 bg-cover-center side-image position-relative" :class="{'vertical': isVertical}" :style="{'background-image': sideImage}">
          <div class="bg-custom-gradient position-absolute" v-if="content.icon && !content.hide_gradient"></div>
          <svg class="position-absolute english-icon" width="50" height="24" xmlns="http://www.w3.org/2000/svg" v-if="content.english_content">
            <g fill="none" fill-rule="evenodd">
              <rect stroke="#FFF" stroke-width="1.5" x=".75" y=".75" width="48.5" height="22.5" rx="11.25"/>
              <text font-size="18" font-weight="bold" fill="#FFF">
                <tspan x="8.575" y="18">ENG</tspan>
              </text>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </component>
</template>

<style lang="scss" scoped>

  [tile-component] {
    .tile__text-section {
      overflow: hidden;

      h1.text-stroke {
        text-stroke: 3px $white;
        -webkit-text-stroke: 3px $white;
        margin: 0 !important;
        color: transparent;
        font-size: 12rem;
      }

      .dotdotdot-title, .dotdotdot-subtitle {
        overflow: hidden;
        text-overflow: ellipsis;

        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        &.h1, &.h2, &.display-1 {
          -webkit-line-clamp: 1;
        }
      }
    }
  }

  .item--largesquarecontent {
    @include media-breakpoint-up(lg) {
      .tile__text-section  {
        padding-right: 3rem !important;
      }
    }
  }

  .item--ultrawidecontent {
    .background  {
      background-position: right;
    }
  }
</style>
